// @flow
import React, { Component } from 'react';

import { cyan50, cyan600, cyan800 } from 'material-ui/styles/colors';

export default () => (
  <div
    style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      background: cyan50,
      zIndex: 1500,
      position: 'absolute',
    }}
  >
    <div style={{ textAlign: 'center', color: cyan600 }}>
      A Légtér.hu térképe csak WebGL-t támogató böngészővel használható.
      <br />
      Böngészője WebGL-támogatását ellenőrizheti a{' '}
      <a href="http://webglreport.com/" style={{ color: cyan800 }}>
        webglreport.com
      </a>{' '}
      oldalon.
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/Map/WebGLSupportMessage.js